import {FrmShape} from "./FrmShape";
import {EventEmitter} from "nate-react-api-helpers";

export const EPS = 1e-6;

export type FrmPointChangeEvent = {
    name: string;
    adjustmentId?: number;
}

export class FrmShapePoint {
    shape: FrmShape;
    x: number;
    y: number;

    changed = new EventEmitter<FrmPointChangeEvent>();

    constructor(shape: FrmShape, x: number, y: number) {
        this.shape = shape;
        this.x = x;
        this.y = y;
    }

    clone() {
        return new FrmShapePoint(this.shape, this.x, this.y);
    }

    copyFrom(frmShapePoint: FrmShapePoint) {
        this.x = frmShapePoint.x;
        this.y = frmShapePoint.y;
    }

    getGraphic() {
        return this.shape.thing.graphic;
    }

}

export function distance(a: FrmShapePoint, b: FrmShapePoint): number {
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    return Math.sqrt(dx * dx + dy * dy);
}
